import moment from 'moment';
import { Table, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useSmallFleets } from '../context/SmallFleets.context';

const { Text } = Typography;

export const SmallFleetsTable = () => {
    const {
        smallFleets,
        pagination,
        loading,
        total,
        setPagination,
    } = useSmallFleets();

    const onPageChange = (page: number, pageSize: number) => setPagination({
        limit: pageSize,
        page,
    });

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center' as 'center',
            render: (createdAt: string) => (
                <div>
                    {moment(createdAt).format('MMM DD, YYYY')}
                </div>
            ),
        },
        {
            title: 'key Name',
            dataIndex: 'keyName',
            key: 'keyName',
            align: 'center' as 'center',
        },
        {
            title: 'Drivers',
            dataIndex: 'drivers',
            key: 'drivers',
            align: 'center' as 'center',
            render: (drivers: any) => (
                <Text>
                    {drivers.length}
                </Text>
            ),
        },
        {
            title: 'Actions',
            dataIndex: '_id',
            key: '_id',
            width: 100,
            fixed: 'right' as 'right',
            // eslint-disable-next-line react/display-name
            render: (id: any, { name }: any) => (
                <Link to={`/v2/small-fleet/${id}?name=${name}`}>
                    Details
                </Link>
            ),
        },
    ];

    return (
        <Table
            rowKey="_id"
            dataSource={smallFleets}
            columns={columns}
            loading={loading}
            pagination={{
                total,
                current: pagination.page,
                pageSize: pagination.limit,
                onChange: onPageChange,
                showSizeChanger: true,
            }}
        />
    );
};

export default SmallFleetsTable;
